module.exports = __webpack_public_path__ + "img/AndroidQR.47de293a.png";